export default "__VITE_ASSET__CyNDwRkA__"